<template>
	<div>
		<div class="last-result">
			<div class="last-result_header">
				<div class="last-result_command">
					<img :src="$hostname + match.home_image_ref" alt="">
					<span>{{ match.home_name }}</span>
				</div>
				<div class="last-result_heading">Последние результаты</div>
				
				<div class="last-result_command">
					<span>{{ match.away_name }}</span>
					<img :src="$hostname + match.away_image_ref" alt="">
				</div>
			</div>
			
			<div class="last-result_content">
				<div class="last-result_col-mid" v-for="(homeItems, homeType, index) in home" :key="homeType + index + '-home'">
					<div v-for="(homeItem, homeTitle, index) in homeItems" :key="homeTitle + index + '-home'">
						<div class="last-result_row __right" v-for="event in homeItem.events" :key="event.id">
							<div class="last-result_info __right">
								<div class="last-result_text-1">
									<div>
										<span>{{ event.home_name }}</span>
										<br>
										<strong>{{ event.home_score }}</strong>
									</div>
									<i>-</i>
									<div>
										<strong>{{ event.away_score }}</strong>
										<br>
										<span>{{ event.away_name }}</span>
									</div>
								</div>
								<div class="last-result_text-2">
									<span>{{ homeTitle }} -</span> {{ getDate(event.startdate) }}</div>
							</div>
							
							<div class="last-result_score" :class="win(match.home_id, event).classes">
								{{ win(match.home_id, event).text }}
							</div>
						</div>
					</div>
				</div>
				<div class="last-result_col-mid" v-for="(awayItems, awayType, index) in away" :key="awayType + index + '-away'">
					<div v-for="(awayItem, awayTitle, index) in awayItems" :key="awayTitle + index + '-away'">
						<div class="last-result_row" v-for="event in awayItem.events" :key="event.id">
							<div class="last-result_score" :class="win(match.away_id, event).classes">
								{{ win(match.away_id, event).text }}
							</div>
							
							<div class="last-result_info __left">
								<div class="last-result_text-1">
									<div>
										<span>{{ event.home_name }}</span>
										<strong>{{ event.home_score }}</strong>
									</div>
									<i>-</i>
									<div>
										<strong>{{ event.away_score }}</strong>
										<span>{{ event.away_name }}</span>
									</div>
								</div>
								<div class="last-result_text-2">
									<span>{{ awayTitle }} -</span> {{ getDate(event.startdate) }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	
	export default {
		props: ['home', 'away', 'match'],
		
		data() {
			return {
				
			}
		},
		
		methods: {
			getDate(date) {
				return moment(date).locale('ru').format('D MMMM Y');
			},
			win(id, item) {
				if (id === item.home_id && item.home_score > item.away_score) {
					return {
						text: 'В',
						classes: ['__win']
					};
				} else if (id === item.away_id && item.home_score < item.away_score) {
					return {
						text: 'В',
						classes: ['__win']
					};
				} else if (item.home_score === item.away_score) {
					return {
						text: 'Н',
						classes: ['__draw']
					};
				}
				
				return {
					text: 'П',
					classes: ['__fail']
				};
			}
		}
	}
</script>